import React from 'react'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { flowRight, get } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'

import InactiveAdModal from 'components/Ads/InactiveAdModal/InactiveAdModal'
import AppContext from 'components/AppContext'
import AuthTosModal from 'components/Auth/AuthTos/AuthTosModal/AuthTosModal'
import AuthLoginConfirmModal from 'components/Auth/AuthLoginConfirm/AuthLoginConfirmModal/AuthLoginConfirmModal'
import AuthFailedMessageModal from 'components/Auth/AuthFailedMessage/AuthFailedMessageModal/AuthFailedMessageModal'

import getModals from 'graphql/modal/getModals.gql'

const Modals = ({ modals }) => {
    const getCurrentModal = () => {
        return get(modals, '[0]', null)
    }

    const renderModal = () => {
        const modal = getCurrentModal()
        if (!modal) return null

        const { name, data } = modal

        switch (name) {
        case 'auth-failed-message':
            return <AuthFailedMessageModal message={data.message} />
        case 'auth-tos-modal':
            return <AuthTosModal />
        case 'auth-login-confirm-modal':
            return <AuthLoginConfirmModal />
        case 'inactive-ad-modal':
            return (
                <InactiveAdModal
                    vertical={data.vertical}
                    adId={data.adId}
                />
            )
        default:
            throw new Error('Invalid modal:', modal)
        }
    }

    return (
        <AppContext context="modal">
            {renderModal()}
        </AppContext>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    graphql(getModals, {
        name: 'modals',
        props: (data) => ({
            modals: data.modals.modals,
        }),
    }),
)(Modals)
